export default [
    {
        path: '/(uk/|ru/)?/wolt/aggregators',
        name: 'woltAggregators',
        component: () => import('../views/wolt/aggregators/table'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Агрегаторы',
        },
    }, {
        path: '/(uk/|ru/)?/wolt/create',
        name: 'WoltAggregatorsCreate',
        component: () => import('../views/wolt/aggregators/create'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Агрегатор создание',
        },
    }, {
        path: '/(uk/|ru/)?/wolt/edit',
        name: 'WoltAggregatorsEdit',
        component: () => import('../views/wolt/aggregators/edit'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Агрегатор редактирование',
        },
    }, {
        path: '/(uk/|ru/)?/wolt/couriers',
        name: 'Woltcouriers',
        component: () => import('../views/wolt/couriers/table'),
        meta: {
            requiresAuth: true,
            title: 'Wolt курьеры',
        },
    }, {
        path: '/(uk/|ru/)?/wolt/transactions',
        name: 'Wolttransactions',
        component: () => import('../views/wolt/transactions'),
        meta: {
            requiresAuth: true,
            title: 'Wolt транзакции',
        },
    }, {
        path: '/(uk/|ru/)?/wolt/work-rules',
        name: 'WoltworkRules',
        component: () => import('../views/wolt/workRules/table'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Условия Работ',
        },
    }, {
        path: '/(uk/|ru/)?/wolt/work-rules/create',
        name: 'WoltworkRulesCreate',
        component: () => import('../views/wolt/workRules/create'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Условия Работ',
        },
    }, {
        path: '/(uk/|ru/)?/wolt/earnings',
        name: 'WoltEarnings',
        component: () => import('../views/wolt/earnings'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Зароботок',
        },
        children: [{
            path: '/(uk/|ru/)?/wolt/earnings',
            name: 'WoltEarningsCurrent',
            component: () => import('../views/wolt/earnings/table/current'),
            meta: {
                requiresAuth: true,
                title: 'Wolt Зароботок',
                activeSideIcon:'#icon-bars',
            },
        }, {
            path: '/(uk/|ru/)?/wolt/archive',
            name: 'WoltEarningsArchive',
            component: () => import('../views/wolt/earnings/table/archive'),
            meta: {
                requiresAuth: true,
                title: 'Wolt Архив',
                activeSideIcon:'#icon-bars',
            },
        },]
    }, {
        path: '/(uk/|ru/)?/wolt/metrics',
        name: 'Woltmetrics',
        component: () => import('../views/wolt/metrics/index'),
        meta: {
            requiresAuth: true,
            title: 'Wolt Меетрики',
            activeSideIcon:'#icon-bars',
        },
    }, {
        path: '',
        name: 'couriersAgreements',
        component: () => import('../views/wolt/couriersAgreements/index'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bars',
        },
        children: [{
            path: '/(uk/|ru/)?/wolt/couriers-agreements',
            name: 'wolt_docs',
            component: () => import('../views/wolt/couriersAgreements/docs.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-bars',
                title: 'Wolt Документы',
                type: 'draft'
            },
        }, {
            path: '/(uk/|ru/)?/wolt/couriers-agreements/signed',
            name: 'wolt_docs-signed',
            component: () => import('../views/wolt/couriersAgreements/docs.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-bars',
                title: 'Wolt Документы подписанные',
                type: 'sign'
            },
        }]
    }, {
        path: '',
        component: () => import('../views/wolt/signUp/index.vue'),
        meta: {
            requiresAuth: true,
            altNavSubMenuActive:'/promotions/referrals-list',
        },
        children: [{
            path: '/(uk/|ru/)?/wolt/sign-up',
            name: 'WoltSignUpNew',
            component: () => import('../views/wolt/signUp/tables/new.vue'),
            meta: {
                requiresAuth: true,
                title: 'Регистрация новые',
                type: 'new',
            },
        }, {
            path: '/(uk/|ru/)?/wolt/sign-up/onboard',
            name: 'WoltSignUpOnboard',
            component: () => import('../views/wolt/signUp/tables/new.vue'),
            meta: {
                requiresAuth: true,
                title: 'Регистрация на расмотрении',
                type: 'onboard',
            },
        }, {
            path: '/(uk/|ru/)?/wolt/sign-up/finished',
            name: 'WoltSignUpFinished',
            component: () => import('../views/wolt/signUp/tables/new.vue'),
            meta: {
                requiresAuth: true,
                title: 'Регистрация законченные',
                type: 'finished',
            },
        },]
    }, {
        path: '/(uk/|ru/)?/wolt/sign-up/edit',
        name: 'WoltSignUpEdit',
        component: () => import('../views/wolt/signUp/forms/edit.vue'),
        meta: {
            requiresAuth: true,
            title: 'Обработка кандидата',
            activeSideIcon:'#icon-bars',
        },
    }, {
        path: '',
        name: 'heldBonusesIndex',
        component: () => import('../views/wolt/held-bonuses/index'),
        meta: {
            requiresAuth: true,
        },
        children: [{
            path: '/(uk/|ru/)?/wolt/held-bonuses',
            name: 'heldBonusesHolded',
            component: () => import('../views/wolt/held-bonuses/tabs/held'),
            meta: {
                requiresAuth: true,
                title: 'Удержанные бонусы: История',
                activeSideIcon:'#icon-bars',
            }
        }, {
            path: '/(uk/|ru/)?/wolt/held-bonuses/history',
            name: 'heldBonusesHistory',
            component: () => import('../views/wolt/held-bonuses/tabs/history'),
            meta: {
                requiresAuth: true,
                title: 'Удержанные бонусы: История',
                activeSideIcon:'#icon-bars',
            }
        }],
    }, {
        path: '/(uk/|ru/)?/wolt/orders',
        name: 'WoltOrders',
        component: () => import('../views/wolt/orders'),
        meta: {
            requiresAuth: true,
            title: 'Заказы',
            activeSideIcon:'#icon-bars',
        },
    }, {
        path: '/(uk/|ru/)?/wolt/on-board',
        name: 'WoltSignUpOnBoard',
        component: () => import('../views/wolt/onBoard/index.vue'),
        meta: {
            requiresAuth: true,
            title: 'Онбоард',
            activeSideIcon:'#icon-bars',
        },
    },
]
